import $ from 'jquery';

export const initModalBanner = () => $("#bannerModal").modal("toggle");
